module.exports = __webpack_public_path__ + "img/util-hot_water.732b3b5b.svg";